import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      gap: '1.5rem',
      flexDirection: 'column',
      '& > h2': {
        textAlign: 'center'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
